/**
 * Feature Flag Service Public API
 *
 * External code should ONLY import from this file.
 * Provider implementations are not exposed.
 */

import { isOnPrem } from '../../config'
import useFirebaseFeatureFlags from './hooks/useFirebaseFeatureFlags'
import useStaticFeatureFlags from './hooks/useStaticFeatureFlags'

// Compile-time hook selection based on environment
// At build time, webpack replaces process.env.REACT_APP_ENV,
// allowing dead code elimination to remove unused implementations
let useFeatureFlagsImpl
if (isOnPrem) {
  useFeatureFlagsImpl = useStaticFeatureFlags
} else {
  useFeatureFlagsImpl = useFirebaseFeatureFlags
}
export const useFeatureFlags = useFeatureFlagsImpl

// Types
export type { FeatureFlagHook } from './types'
// For backward compatibility
export type { FeatureFlagHook as FeatureFlagProvider } from './types'
